export function validateAccountName(
  accountName: string,
  countryCode?: string,
): { isValid: boolean; warning?: string } {
  // Nigeria auto-resolves account names, so no validation needed
  if (countryCode === "NG") {
    return { isValid: true };
  }

  const trimmed = accountName.trim();

  // Empty check
  if (!trimmed) {
    return { isValid: false };
  }

  // Normalize multiple spaces to single space
  const normalized = trimmed.replace(/\s+/g, " ");
  const parts = normalized.split(" ");

  // Single word detected - allow but warn
  if (parts.length < 2) {
    return {
      isValid: true,
      warning:
        'For companies with single names, please add "Ltd", "Inc", or similar',
    };
  }

  // Check for very short words (< 2 chars each)
  const hasVeryShortParts = parts.some((part) => part.length < 2);
  if (hasVeryShortParts) {
    return {
      isValid: true,
      warning: "Name appears incomplete. Please verify it matches the account.",
    };
  }

  return { isValid: true };
}
